import Vue from 'vue'
import Router from 'vue-router'
import Vuetify from 'vuetify'
import Inicio from '@/components/Inicio'
import money from '../lib/v-money'

import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Router)
Vue.use(Vuetify, {
  theme: {
    application: '#ffffff',
    primary: '#3f51b5',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
})
Vue.use(money)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: Inicio
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js